import React from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, BookOpen, CheckCircle, Lock } from 'lucide-react';
import { useAppContext } from '../../core/App';
// SYNCED SOURCE OF TRUTH
import { CURRICULUM_MAP } from '../../core/constants/modules';

export default function CurriculumHub() {
  const { handleNavigate, goToDashboard, userProfile } = useAppContext();

  const isModuleComplete = (moduleId) => {
    return userProfile?.completedModules?.[moduleId]?.status === 'mastered';
  };

  return (
    <div className="max-w-4xl mx-auto pb-20 pt-6 animate-fade-in px-4 sm:px-0">
      <div className="flex items-center mb-8">
        <button 
          onClick={goToDashboard}
          className="p-2 rounded-full bg-white shadow-sm hover:bg-gray-50 transition mr-4"
        >
          <ChevronLeft className="w-6 h-6 text-gray-600" />
        </button>
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 flex items-center gap-3">
            <BookOpen className="text-blue-600" /> Skills Curriculum
          </h1>
          <p className="text-gray-500 text-sm sm:text-base">
            Master the foundation of workforce readiness.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* MAPPING OVER UNIVERSAL SOURCE OF TRUTH */}
        {CURRICULUM_MAP.map((module, index) => {
          const isComplete = isModuleComplete(module.id);
          const isLocked = module.locked;

          return (
            <motion.div
              key={module.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.05 }}
              onClick={() => {
                if (!isLocked) {
                  handleNavigate(module.id);
                }
              }}
              className={`
                relative p-5 rounded-2xl border transition-all duration-200 group
                ${isLocked 
                  ? 'bg-gray-50 border-gray-200 opacity-70 grayscale cursor-not-allowed' 
                  : 'bg-white border-gray-100 hover:border-blue-300 hover:shadow-xl cursor-pointer'
                }
              `}
            >
              <div className="flex items-center justify-between mb-4">
                <div className={`p-3 rounded-xl ${module.bg} ${module.color}`}>
                  <module.icon size={24} />
                </div>
                {isComplete ? (
                  <CheckCircle className="text-green-500" size={20} />
                ) : isLocked ? (
                  <Lock className="text-gray-400" size={18} />
                ) : (
                  <div className="w-2 h-2 rounded-full bg-blue-500 animate-pulse" />
                )}
              </div>

              <div>
                <span className="text-[10px] font-bold uppercase tracking-widest text-gray-400">
                  {module.category}
                </span>
                <h3 className="text-lg font-bold text-gray-800 group-hover:text-blue-600 transition-colors">
                  {module.title}
                </h3>
              </div>

              {isLocked && (
                <div className="mt-3 pt-3 border-t border-gray-100">
                  <p className="text-[10px] font-bold text-gray-400 uppercase">Coming Soon</p>
                </div>
              )}
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}